import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import NProgress from 'nprogress';
import {
    $http,
    MAP_LIST
} from '$http';
// 新增 编辑
export default {
    mixins: [services],
    data() {
        return {
            AddDialogVisible: false,
            loading: false,
            title: '',
            CheckUserId:'',
            form: this.getFormData(),
            OptionTypes: [{
                Id: 0,
                name: '不需要'
            }, {
                Id: 1,
                name: '需要'
            }],
            ModuleEmployee:[{
				Id: 0,
				EmployeeName: '全部'
			}],

        }
    },
    methods: {
        getFormData() {
            return cloneDeep({
                "CheckUserId":'',
                "NetCheckId": 0,
                "CheckStatus": 0,
                "IT_Service": '',
                "IT_ServiceMoney": ''

            });
        },
        show(opts) {
            this.form = this.getFormData()
            this.AddDialogVisible = true
            this.title = opts.title
            this.form.NetCheckId = opts.NetCheckId
            this.form.CheckStatus = opts.CheckStatus
             this.GetModuleEmployeeList();
            //this.form.IT_ServiceMoney = opts.IT_ServiceMoney
        },
        // 提交
        submit() {
            // 判断
            let flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "是否需要上门服务",
                    value: this.form.IT_Service,
                    required: true,
                }]
            });
            if (!flag) {
                return false;
            }
            if (this.form.IT_Service == 1) {
                // 需要时要填写金额
                if (this.form.IT_ServiceMoney == 0) {
                    this.$notify({
                        title: '警告',
                        message: '请填写涉及的服务费用!',
                        type: 'warning'
                    });
                    return;
                }
            }
            if(this.form.CheckUserId==0)
            {
                        this.$notify({
                        title: '警告',
                        message: '请选择网络监测人员!',
                        type: 'warning'
                    });
                    return;
            }
            this.CompleteCheck()

        },
        //取消
        close() {
            this.AddDialogVisible = false
        }

    },
}


// WEBPACK FOOTER //
// ./src/pages/Network/networkCheck/components/completeDialog/vm.js